module.exports = __webpack_public_path__ + "static/media/SAINT_6943.94deee61.jpg";